"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _numberFormatter = require("../../helpers/numberFormatter");
var useEstimatedPnLValue = function useEstimatedPnLValue(formValues, position, mode) {
  var estimatedPnLValue = (0, _react.useMemo)(function () {
    var _position$quoteProduc;
    var decimalPlaces = (position === null || position === void 0 || (_position$quoteProduc = position.quoteProduct) === null || _position$quoteProduc === void 0 ? void 0 : _position$quoteProduc.DecimalPlaces) || 2;
    if (!(formValues !== null && formValues !== void 0 && formValues.amount) || !(formValues !== null && formValues !== void 0 && formValues.closingPrice) && !(position !== null && position !== void 0 && position.MarkPrice) || !position) {
      return (0, _numberFormatter.formatNumberToLocale)(0, decimalPlaces);
    }
    var PositionType = position.PositionType,
      EntryPrice = position.EntryPrice,
      MarkPrice = position.MarkPrice;
    var amount = formValues.amount,
      closingPrice = formValues.closingPrice;

    // Use closingPrice for Limit, MarkPrice for Market
    var price;
    if (mode === 'Limit') {
      price = closingPrice;
    } else {
      price = MarkPrice;
    }
    var pnl = 0;
    if (PositionType === 'Long') {
      pnl = (price - EntryPrice) * amount;
    } else {
      pnl = (EntryPrice - price) * amount;
    }
    return (0, _numberFormatter.formatNumberToLocale)(pnl, decimalPlaces);
  }, [formValues, position, mode]);
  return {
    estimatedPnLValue: estimatedPnLValue
  };
};
var _default = exports["default"] = useEstimatedPnLValue;